function insertAfter (newElement, targetElement) {
    let parent = targetElement.parentNode;
    if (parent.lastChild === targetElement) {
        parent.appendChild(newElement)
    }else {
        parent.insertBefore(newElement, targetElement.nextSibling);
    }
}

function change_product_media(){
    let product_media_wrapper_main = document.getElementById('product__media_wrapper_main')
    let product_price_main = document.getElementById('product_price_main')

    if (window.innerWidth < 750) {
        // insertAfter(product_media_wrapper_main, product_price_main);
    } else {
        let product_info = document.getElementById('product_info')
        let product_8nnuqwe = document.getElementById('product_8nnuqwe')

        product_8nnuqwe.insertBefore(product_media_wrapper_main, product_info)
    }


}

function change_product_detail() {
    if (window.innerWidth < 750) {
        let product_accordions = document.querySelectorAll('.product__accordion ')

        for (let i = 0; i < product_accordions.length; i++) {

            if (i === 0) {
                // 第一个
                product_accordions[i].style.borderBottom = '0px'
                product_accordions[i].style.borderTop = '1.5px solid #232323'
                product_accordions[i].style.borderLeft = '1.5px solid #232323'
                product_accordions[i].style.borderRight = '1.5px solid #232323'
                product_accordions[i].style.borderRadius = '1.6rem 1.6rem 0 0'


                product_accordions[i].style.paddingTop = '1.2rem'
                product_accordions[i].style.paddingLeft = '1.2rem'
                product_accordions[i].style.paddingRight = '1.2rem'



                product_accordions[i].firstElementChild.style.borderBottom = '1.5px solid #000000'

            }
            if (i === product_accordions.length - 1) {
                // 最后一个
                product_accordions[i].style.borderBottom = '1.5px solid #232323'
                product_accordions[i].style.borderTop = '0px'
                product_accordions[i].style.borderLeft = '1.5px solid #232323'
                product_accordions[i].style.borderRight = '1.5px solid #232323'
                product_accordions[i].style.borderRadius = '0 0 1.6rem 1.6rem '


                product_accordions[i].style.paddingLeft = '1.2rem'
                product_accordions[i].style.paddingRight = '1.2rem'
                product_accordions[i].style.paddingBottom = '1.2rem'
            }

            if (i !== product_accordions.length - 1 && i !== 0) {
                // 中间的
                product_accordions[i].style.borderLeft = '1.5px solid #232323'
                product_accordions[i].style.borderRight = '1.5px solid #232323'
                product_accordions[i].style.paddingLeft = '1.2rem'
                product_accordions[i].style.paddingRight = '1.2rem'

                product_accordions[i].style.borderTop = '0px'
                product_accordions[i].style.borderBottom = '0px'
                product_accordions[i].firstElementChild.style.borderBottom = '1.5px solid #000000'

            }

        }
    }
}

function change_mobile_product_from_position() {
    if (window.innerWidth < 750) {
        // let product_form = document.getElementById('product_form_jijqwensdf')
        // let product_info = document.getElementById('product_info')
        //
        // product_info.appendChild(product_form)
    }
}


window.addEventListener("resize", () => {
    change_product_media()
})


change_mobile_product_from_position()
change_product_detail()
change_product_media()